// import React from 'react'
// import USTemplateDefault from 'src/components/template/us'
// import { sportIds } from 'src/constants/personalizationIds'
// export default (props) => (
//   <USTemplateDefault
//     location={props.location}
//     lang="es"
//     market="us"
//     video={
//       'https://assets.fubo.tv/marketing/lp/videos/compressed/ES_WorldCup2022_1280x720_LP_10s.mp4'
//     }
//     staticAnnotation={{
//       logoUrl:
//         'https://assets-imgx.fubo.tv/marketing/lp/images/annotations/world_cup_qatar_2022_telemundo.png?h=120&ch=width&auto=format,compress',
//       height: 80,
//     }}
//     title="Ve la Copa Mundial de la FIFA 2022™"
//     subtitle="Todos los partidos en vivo por Telemundo"
//     networkHeadline="Ve la Copa Mundial de la FIFA"
//     networkSet="soccerLatino"
//     customNetworks={['telemundo', 'universo', 'fs1']}
//     sportId={sportIds.Soccer}
//     caRedirectUrl={'/ca/dazn/'}
//   />
// )

// TEMPORARY NBC DISPUTE
import React from 'react'
import RedirectTemplate from 'src/components/template/redirect'
export default (props) => <RedirectTemplate location={props.location} destination="/tv/" />
